import { Helmet } from "react-helmet-async";

const SchemaMarkup = () => {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Odontología Lash",
    "url": "https://odontologialash.com",
    "logo": "https://odontologialash.com/logo.png",
    "image": "https://odontologialash.com/imagen.png",
    "description": "Clínica dental especializada en tratamientos odontológicos avanzados.",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Dirección de tu clínica",
      "addressLocality": "Ciudad",
      "addressRegion": "Provincia",
      "postalCode": "Código Postal",
      "addressCountry": "AR"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+54 11 1234-5678",
      "contactType": "customer service"
    },
    "sameAs": [
      "https://www.facebook.com/odontologialash",
      "https://www.instagram.com/odontologialash"
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schemaData)}
      </script>
    </Helmet>
  );
};

export default SchemaMarkup;
